const id_sales_po = {
    label: {
        process_so: "proses SO"
    }
}

export default id_sales_po;